import './messenger'
import {addToEditor} from "@/utils/editor";
let msgObj = new Messenger('editorParent', 'Editor');

msgObj.listen(function (msg) {
  try {
    let data = JSON.parse(msg);
    if (data.cmd === "insertHtml") {
      addToEditor(data.param)
    }
  } catch (e) {
    console.log(e);
  }
})
